export const MAX_WORK_SHIFT_DURATION_HOURS = 7

export const MATRICULE_PREFIX = 'AGD'

export const MINIMUM_BREAK_BETWEEN_SHIFTS_MINUTES = 20
export const MAX_WEEKLY_HOURS = 35
export const MAX_CONSECUTIVE_WORK_DAYS = 6
